import styled from 'styled-components';

import { maxWidth } from '@calm-web/design-system';

export const BookDiv = styled.div`
	background-color: #f4f6f8;
	position: relative;
	overflow: hidden;
`;

export const BookHero = styled.div`
	background-image: url(/_n/images/book/hero.webp);
	background-repeat: no-repeat;
	background-position: 50%;
	background-size: 1138px 750px;
	width: 100%;
	height: 750px;
	margin: 125px auto;
	${maxWidth('desktop')} {
		margin: 50px auto;
	}
`;
